












import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryActivityList, DeleteActivity } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import CreateActivityDialog from './CreateActivityDialog.vue'
import UpdateActivityDialog from './UpdateActivityDialog.vue'
import BindActivityGoodsDialog from './BindActivityGoodsDialog.vue'
import router from '@/router'
import constant from '@/utils/constant'
import { GoodsActivityTypeFormat } from '@/utils/tyepconvert'

@Component({
  components: {
    VQuery,
    VTable,
    CreateActivityDialog,
    UpdateActivityDialog,
    BindActivityGoodsDialog,
  },
})
export default class ActivityList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    endTime: '',
    endTimeq: null,
    // activityType: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '活动类型', param: 'activityType', type: 'select', selectData: constant.GoodsActivityType },
    { title: '活动名称', param: 'activityName' },
    { title: '活动开始时间', param: 'startTime', type: 'date' },
    { title: '活动结束时间', param: 'endTimeq', type: 'date' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建活动', type: 'primary', click: this.createActivity }]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '活动ID', param: 'id' },
    { title: '活动名称', param: 'activityName' },
    { title: '活动标题', param: 'activityTitle' },
    { title: '活动标签', param: 'activityLabel' },
    // { title: '活动类型', param: 'activityType', formatter: GoodsActivityTypeFormat},
    { title: '限购数量', param: 'maxQty', formatter: (data:number)=> {return data>0 ? data: "无"} },
    { title: '活动开始时间', param: 'startTime', formatter: DateFormat },
    { title: '活动结束时间', param: 'endTime', formatter: DateFormat },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 220,
      operation: [
        { title: '关联商品', icon: 'el-icon-document', click: this.openBind },
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public createActivity() {
    const dialog = this.$refs.createActivityDialog as CreateActivityDialog
    dialog.open()
  }

  public openUpdate(data: any) {
    const dialog = this.$refs.updateActivityDialog as UpdateActivityDialog
    dialog.open(data)
  }
  public openBind(data: any) {
    const dialog = this.$refs.bindActivityGoodsDialog as BindActivityGoodsDialog
    dialog.open(data)
    // router.push('/bindActivityGoods?id='+data.id+"&activityName="+data.activityName)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    if (param.endTimeq) {
      param.endTime = ',' + param.endTimeq
    }

    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryActivityList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteActivity({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
